import { FC, Ref } from "react";
import Dialog from "../Dialog/Dialog";
import { DialogHandle } from "../Dialog/DialogTypes";
import dialogCss from "../../common-styling/Dialog.module.css";
import { useServices } from "../../services/Services";
import { Osdk } from "@osdk/client";
import { User } from "@unruly-osdk/sdk";

const FeedbackDialog: FC<{ ref: Ref<DialogHandle> }> = function ({ ref }) {
  const services = useServices();
  async function saveFeedback(data: FormData) {
    const user = (await services.User.getCurrentAsync()) as Osdk.Instance<User>; // We always have a user here
    const feedback = data.get("feedback");
    if (feedback && typeof feedback === "string") {
      return await services.User.createFeedback(user, feedback);
    }
  }
  function onError(error: unknown) {
    console.error(error);
    return "Something went wrong submitting your feedback. If this persists, you can contact Unruly support through accounts@unrulycorp.com";
  }
  return (
    <Dialog
      title="Provide Feedback"
      action="Submit"
      onSubmit={saveFeedback}
      onError={onError}
      ref={ref}
    >
      <div className={dialogCss["field-group"]}>
        <div className={dialogCss.field}>
          <textarea
            name="feedback"
            autoFocus
            placeholder="Please provide any feedback, issues or suggestions you have"
            minLength={1}
            rows={10}
          />
        </div>
      </div>
    </Dialog>
  );
};

export default FeedbackDialog;
